var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0193 5.08848V9.78307L16.678 10.816C16.7217 10.8287 16.8167 10.8296 16.8604 10.816L23.9991 6.05569C23.9991 5.49231 23.4677 5.08847 23.1679 5.08847L15.0193 5.08848Z",
    fill: "#0072C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0193 11.5344L16.5331 12.5629C16.7464 12.718 17.0033 12.5629 17.0033 12.5629C16.7472 12.718 24 7.95316 24 7.95316V16.5815C24 17.5207 23.392 17.9147 22.7085 17.9147H15.0184L15.0193 11.5344Z",
    fill: "#0072C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18164 9.37013C6.6658 9.37013 6.25477 9.60987 5.95129 10.0885C5.6478 10.5672 5.4956 11.2009 5.4956 11.9896C5.4956 12.7901 5.6478 13.4229 5.95129 13.888C6.25477 14.354 6.65304 14.5857 7.14519 14.5857C7.65281 14.5857 8.05564 14.3595 8.35275 13.9069C8.64985 13.4544 8.79932 12.8261 8.79932 12.0231C8.79932 11.1856 8.65532 10.5339 8.36641 10.0679C8.07752 9.60267 7.68289 9.37013 7.18164 9.37013Z",
    fill: "#0072C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.70423V21.0704L14.1263 24V0L0 2.70423ZM9.45267 14.9923C8.85577 15.7692 8.07747 16.1587 7.11688 16.1587C6.18091 16.1587 5.419 15.7819 4.82935 15.0292C4.2406 14.2756 3.94532 13.2949 3.94532 12.0852C3.94532 10.8079 4.24425 9.77493 4.84301 8.98613C5.44179 8.19741 6.23468 7.80259 7.22169 7.80259C8.15403 7.80259 8.90864 8.17937 9.48373 8.93476C10.0597 9.69013 10.3477 10.6853 10.3477 11.9211C10.3485 13.1912 10.0497 14.2152 9.45267 14.9923Z",
    fill: "#0072C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.3c4ad43f0e22774e73983617892e4478.svg";
export { ForwardRef as ReactComponent };